// roles.js
const ROLES = {
    ADMIN: "admin",
    AGENT: "agent",
    ORGANIZATION: "organisation",
  };
  
  export default ROLES;
  